import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {StyleType} from "@catui/types";
import {FormBuilder, FormGroup} from "@angular/forms";
import {GenericResourceService} from "@catfeatures/services/generic-resource.service";
import {NotificationsService, ProjectService} from "@catcore/services";
import {ActiveModal} from "@catmodules/widgets/slide-in-modal/utils/modal-ref";
import {EntitySchemaService} from "@catcore/services/entity-schema.service";
import {EntitySchemaType} from "@catcore/utils/json-schema/entity-schema-to-json-schema";
import {buildFormControlsFromSchema} from "@catuiform/shared/form-builder";
import {Subscription} from "rxjs";
import {Project} from "@catcore/types/api-v2";
import {isNullOrUndefined} from "util";
import {sortByLabelFunc} from "@catcore/utils";

@Component({
  selector: 'catapp-modify-ggw-dynamic-route',
  templateUrl: './modify-ggw-dynamic-route.component.html',
  styleUrls: ['./modify-ggw-dynamic-route.component.scss']
})
export class ModifyGgwDynamicRouteComponent implements OnInit, OnDestroy {

  styleType = StyleType;
  form: FormGroup;

  @Output() afterUpdate = new EventEmitter<any>();
  @Output() afterCreate = new EventEmitter<any>();

  project: Project;

  templateOptions = [];

  private templateSubscription: Subscription;

  private _ggwDynamicRoute: any;
  private readonly modelSchema;

  constructor(private formBuilder: FormBuilder,
              private resourceService: GenericResourceService,
              private notification: NotificationsService,
              private activeModal: ActiveModal,
              private projectService: ProjectService,
              schemaService: EntitySchemaService) {
    this.modelSchema = schemaService.getForEntityName(EntitySchemaType['ProjectGgwDynamicRoutes']);
    const formControls = buildFormControlsFromSchema(this.formBuilder, this.modelSchema);
    this.form = this.formBuilder.group(formControls);
  }

  @Input()
  get ggwDynamicRoute(): any {
    return this._ggwDynamicRoute;
  }

  set ggwDynamicRoute(value: any) {
    this._ggwDynamicRoute = value;
    if (this._ggwDynamicRoute) {
      this.form.patchValue(this._ggwDynamicRoute);
      if (this._ggwDynamicRoute._links.hasOwnProperty('template')) {
        this.form.patchValue({template: this._ggwDynamicRoute._links.template.href});
      }
    }
  }

  get formIsReady(): boolean {
    return this.form && Object.keys(this.form.controls).length > 0;
  }

  ngOnInit() {
    if (this.project && !isNullOrUndefined(this.project.id)) {
      this.templateSubscription = this.projectService
        .getGgwDynamicRouteTemplates(this.project)
        .subscribe((templates) => {
          this.updateTemplateOptions(templates);
        });
    }
  }

  ngOnDestroy() {
    if (this.templateSubscription) {
      this.templateSubscription.unsubscribe();
    }
  }

  onSubmit() {
    const create = isNullOrUndefined(this._ggwDynamicRoute.id);
    let service = this.resourceService.findServiceForResource(this.modelSchema.resourceUri);
    if (!create) {
      service = this.resourceService.findServiceForResource(this._ggwDynamicRoute._links.self.href);
    }

    const subscr = service
      .save({
        source: this._ggwDynamicRoute._links.source.href,
        sink: this._ggwDynamicRoute._links.sink.href,
        template: this.form.value.template
      }, create)
      .finally(() => subscr.unsubscribe())
      .subscribe((res) => {
        this.notification.success('Update successful', 'Dynamic route has been saved.');
        this.activeModal.close();
        if (create) {
          this.afterCreate.emit(res);
        } else {
          this.afterUpdate.emit(res);
        }
      });
  }

  sourceLabel() {
    return this.getLabel('source');
  }

  sinkLabel() {
    return this.getLabel('sink');
  }

  private updateTemplateOptions(templates: any) {
    this.templateOptions = [];
    templates.forEach((template) => {
      if (!template._links.hasOwnProperty('model')
        || this.getTemplateModelUri(this.ggwDynamicRoute) === template._links.model.href) {
        this.templateOptions.push({label: template.name, value: template._links.self.href});
      }
    });
    this.templateOptions.sort(sortByLabelFunc);
  }

  private getLabel(deviceRole) {
    if (this._ggwDynamicRoute) {
      if (this._ggwDynamicRoute._links[deviceRole].hasOwnProperty('label')) {
        return this._ggwDynamicRoute._links[deviceRole].label;
      } else {
        return this._ggwDynamicRoute._embedded[deviceRole].name;
      }
    }
  }

  private getTemplateModelUri(ggwDynamicRoute: any) {
    if (ggwDynamicRoute
      && ggwDynamicRoute._embedded
        && ggwDynamicRoute._embedded.template
        && ggwDynamicRoute._embedded.template._links.hasOwnProperty('model')) {
      return ggwDynamicRoute._embedded.template._links.model.href;
    }

    return undefined;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/ggw-dynamic-routes/components/modify-ggw-dynamic-route/modify-ggw-dynamic-route.component.ts